export const DEVICE_UUID = 'mindboxDeviceUUID';
